import { makeAutoObservable } from 'mobx'

import {
  CrimeOsRecordModel,
  FieldGuidedActionConfigType
} from '@crimeos-frontend/shared/crime-os-shared'

class GuidedActionUIStore {
  private _isGuidedActionSidePaneOpen!: boolean
  private _guidedActionConfig!: FieldGuidedActionConfigType
  recordModel!: CrimeOsRecordModel
  cssStyles!: string

  private constructor() {
    this.init()
    makeAutoObservable(this, {}, { autoBind: true })
  }

  private init() {
    this._isGuidedActionSidePaneOpen = false
  }

  get isGuidedActionSidePaneOpen(): boolean {
    return this._isGuidedActionSidePaneOpen
  }
  get guidedActionConfig(): FieldGuidedActionConfigType {
    return this._guidedActionConfig
  }

  setIsGuidedActionSidePaneOpen(
    guidedActionConfig: FieldGuidedActionConfigType,
    recordModel: CrimeOsRecordModel,
    cssStyles: string
  ): void {
    this._isGuidedActionSidePaneOpen = true
    this._guidedActionConfig = guidedActionConfig
    this.recordModel = recordModel
    this.cssStyles = cssStyles
  }

  closeGuidedActionSidePane(): void {
    this.init()
  }

  static createStore = (): GuidedActionUIStore => new GuidedActionUIStore()
}

export default GuidedActionUIStore
